import {
  ApplicationConfig,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
  LOCALE_ID,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { AppInitService } from './core/services/app-init.service';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideHttpClient(withInterceptors([TokenInterceptor])),
    AppInitService,
    // Usar provideAppInitializer para inicializar la aplicación antes de cargarla
    provideAppInitializer(() => {
      const appInitService = inject(AppInitService);
      return appInitService.initializeApp()
    }),
  ],
};


